var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTitleDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 7,
    viewBox: "0 0 6 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8B9799",
    d: "M552.096,22.512 C552.601341,22.512 553.068007,22.3858028 553.496,22.1334085 C553.923993,21.8810141 554.264324,21.5418592 554.516994,21.1159437 C554.769665,20.6900282 554.896,20.2246761 554.896,19.7198873 C554.896,19.1940657 554.767087,18.7181972 554.50926,18.2922817 C554.251433,17.8663662 553.908523,17.5298404 553.48053,17.2827042 C553.052538,17.0355681 552.591028,16.912 552.096,16.912 C551.570033,16.912 551.093053,17.0434554 550.665061,17.3063662 C550.237068,17.569277 549.901893,17.9163192 549.659536,18.347493 C549.417179,18.7786667 549.296,19.2361315 549.296,19.7198873 C549.296,20.2351925 549.422335,20.7058028 549.675006,21.1317183 C549.927676,21.5576338 550.270586,21.8941596 550.703735,22.1412958 C551.136884,22.3884319 551.600972,22.512 552.096,22.512 Z",
    transform: "translate(-549 -16)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleDot);
export default __webpack_public_path__ + "static/media/title-dot.49888eed.svg";
export { ForwardRef as ReactComponent };